import React, { useState } from 'react'
import { Text, Wrapper, Filter, FilterBtn, GridImage, Image, GridInfo, Desc, Tools, Tool, GridButtons, GreenButton, BlackButton, Circle, Container, Title, Hr } from './ProjectElements'
import { projects } from './data'
import { FiCheck } from 'react-icons/fi'

const Projects = () => {
    const [filtered, setFiltered] = useState(projects)

    function getFilter(e) {

        setFiltered([])

        const text = e.target.innerHTML;
        const newList = projects.filter(project => project.filter === text.toLowerCase())
        setFiltered(newList)
    }

    function reset(e) {
        setFiltered(projects)
    }


    const newProjects = filtered.map(project => (
        <Wrapper key={project.name} type={project.name}>

            <GridImage type={project.name}>
                <Image src={project.image} alt={project.alt} />
            </GridImage>
            <GridInfo type={project.name}>
                <Text>{project.name}</Text>
                <Desc>{project.desc}</Desc>
                <Tools>{project.tools.map((tool, i) => <Tool key={i}><FiCheck color="teal" style={{ marginRight: "10px" }} /> {tool}</Tool>)}</Tools>
                <GridButtons>
                    <BlackButton href={project.url} target="_blank" rel="noopener noreferrer" aria-label="Link to Website">Open</BlackButton>
                    <GreenButton href={project.git} target="_blank" rel="noopener noreferrer" aria-label="Link to GitHub">Code</GreenButton>
                </GridButtons>

            </GridInfo>
            <Circle></Circle>
        </Wrapper>

    ))
    return (
        <Container id="projects">
            <Title>Projects</Title>
            <Hr></Hr>
            <Filter>
                <FilterBtn role="button" onClick={reset}>All Projects</FilterBtn>
                <FilterBtn role="button" onClick={getFilter}>Emails</FilterBtn>
                <FilterBtn role="button" onClick={getFilter}>Websites</FilterBtn>
            </Filter>
            {newProjects}

        </Container>
    )
}

export default Projects
